import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'wm-user-renewable-registration-details',
    templateUrl: './user-renewable-registration-details.component.html',
    styleUrls: ['./user-renewable-registration-details.component.css'],
    standalone: false
})
export class UserRenewableRegistrationDetailsComponent implements OnInit {

  registrationId: string;
  topMargin: number;

  constructor(private _route: ActivatedRoute) { }

  ngOnInit() {
    this._route.params.subscribe(parms => {
      this.registrationId = parms['registrationId'];
    });
  }

  setTopMarginForNavbar(pixelHeight: number) {
    this.topMargin = pixelHeight;
  }
}
